import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditClient from "../../components/clients/FormAddEditClient";
import { useGetClient } from "../../hooks/clients/useGetClient";
import LoadingPage from "../../components/global/LoadingPage";

const EditClient = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { isLoading, error, client } = useGetClient(id);

    if (isLoading) return <LoadingPage />;
    if (error) return null;

    const handleSuccess = () => {
        navigate("/clients");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditClient
                isEdit={true}
                currentData={client}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default EditClient;